import React, { useEffect, useMemo, useState } from 'react';
import { array, bool, func } from 'prop-types';

import { Slider } from '@atlas/components';

const propTypes = {
  bonuses: array.isRequired,
  isOpenedDetails: bool.isRequired,
  renderBonus: func.isRequired,
};

const BonusesWrapper = ({ bonuses, isOpenedDetails, renderBonus }) => {
  const [swiper, setSwiper] = useState(null);

  const renderedBonuses = useMemo(() => {
    return bonuses.map(bonus => <Slider.Slide key={bonus.id}>{renderBonus(bonus)}</Slider.Slide>);
  }, [bonuses, renderBonus]);

  const autoplay = useMemo(
    () =>
      isOpenedDetails
        ? false
        : {
            delay: 8000,
          },
    [isOpenedDetails],
  );

  useEffect(() => {
    if (!swiper) return;

    if (isOpenedDetails) {
      swiper.autoplay.stop();
      return;
    }

    swiper.autoplay.start();
  }, [isOpenedDetails, swiper]);

  return bonuses.length > 1 ? (
    <div className="slider-wrapper">
      <Slider
        autoplay={autoplay}
        className="bonus-list-slider"
        nextBtn={<Slider.NextBtn className="arrow next" />}
        onSwiper={setSwiper}
        prevBtn={<Slider.PrevBtn className="arrow prev" />}
        slidesPerView={1}
      >
        {renderedBonuses}
      </Slider>
    </div>
  ) : (
    <div className="registration-bonus-popup__bonus-list">{renderedBonuses}</div>
  );
};

BonusesWrapper.propTypes = propTypes;

export default BonusesWrapper;
